import { getTermMeetingPopularTreatmentTypesThreshold } from './getTermMeetingPopularTreatmentTypesThreshold'
import { POPULAR_TREATMENT_TYPES_DISPLAY_THRESHOLD } from './constants'
import { isNonEmptyObject } from '../../../utils/checks'

interface TaxonomyCount {
  fieldValue: string
  totalCount: number
}

interface CenterData {
  accepted_insurance?: TaxonomyCount[]
  therapies?: TaxonomyCount[]
  treatment_therapies?: TaxonomyCount[]
  whatWeTreat?: TaxonomyCount[]
  whoWeTreat?: TaxonomyCount[]
  treatment_services?: TaxonomyCount[]
  onsite_amenities?: TaxonomyCount[]
  price?: TaxonomyCount[]
  options?: TaxonomyCount[]
}

export const hasTreatmentTypesToDisplay = (
  data: object,
  pageType: string
): boolean => {
  const centerData: CenterData = data[`centers_${pageType}`]

  if (!isNonEmptyObject(centerData)) {
    return false
  }

  const centerTaxonomies = [
    ...(centerData.accepted_insurance || []),
    ...(centerData.therapies || []),
    ...(centerData.treatment_therapies || []),
    ...(centerData.whatWeTreat || []),
    ...(centerData.whoWeTreat || []),
    ...(centerData.treatment_services || []),
    ...(centerData.onsite_amenities || []),
    ...(centerData.price || []),
    ...(centerData.options || [])
  ]

  const count = centerTaxonomies.reduce((acc, taxonomy) => {
    if (
      !getTermMeetingPopularTreatmentTypesThreshold(
        taxonomy.fieldValue,
        taxonomy.totalCount
      )
    ) {
      return acc + 1
    }
    return acc
  }, 0)

  return count >= POPULAR_TREATMENT_TYPES_DISPLAY_THRESHOLD
}
